import { render } from "./SearchView.vue?vue&type=template&id=2c4b94ce&ts=true"
import script from "./SearchView.vue?vue&type=script&lang=ts"
export * from "./SearchView.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__